module.exports = __webpack_public_path__ + "media/application/images/icons/spain-57ec6bb4c2dfc3d913b12387cf789474.svg";